import * as React from 'react';
import { TextareaAutosize } from 'react-autosize-textarea/lib/TextareaAutosize';
import { IProps, SortDropdown } from './SortDropdown';
import State = TextareaAutosize.State;

export class SortDropdownContained<T extends string> extends React.Component<IProps<T>, State> {

    public render() {
        return (
            <div style={sortDropdownContainer}>
                <SortDropdown {...this.props}/>
            </div>
        );
    }
}

const sortDropdownContainer: React.CSSProperties = {
    display: 'flex',
    justifyContent: 'flex-end',
    alignSelf: 'stretch',
    paddingRight: 30
};



// WEBPACK FOOTER //
// ./src/SharedComponents/SortDropdownContained.tsx